// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProBadge":"bcw_a bhc_qn bhc_qo bhc_ua bhc_cy bhc_ty bhc_go bhc_ka"};